import { BooleanInput } from '@angular/cdk/coercion';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

type InputVariant = 'accent' | 'primary' | 'warn' | 'flat' | 'secondary' | 'toggle' | 'with-icon';

@Component({
  selector: 'dmb-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  imports: [MatButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  variant = input<InputVariant>('accent');
  type = input('submit');
  disabled = input<BooleanInput>(false);
  buttonClick = output<MouseEvent>();

  color = computed(() => {
    switch (this.variant()) {
      case 'primary':
        return 'primary';
      case 'warn':
        return 'warn';
      case 'toggle':
        return 'toggle';
      case 'with-icon':
        return undefined;

      default:
        return 'accent';
    }
  });

  classes = computed(() => {
    switch (this.variant()) {
      case 'flat':
        return 'mat-mdc-flat-button';
      case 'secondary':
        return 'mat-mdc-raised-button secondary';
      case 'toggle':
        return 'mat-mdc-toggle-button toggle';
      case 'with-icon':
        return 'with-icon';

      default:
        return 'mat-mdc-raised-button';
    }
  });
}
